import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { variant1, variant2, variant3, variant4, variant5 } from './constants';
import { getModelProduct, getTrimProduct } from '../ModelFiltersContext/utils';
import { makeModelConfiguration, usePricesFromFinancialModel } from '../../utils/financeUtils';
import { isEmpty } from '../../utils/object';
import safelyStringifyJSON from '../../utils/safelyStringifyJSON';
import useProductFinancial from '../../apiHooks/useProductFinancial';
const SpecialOffersContext = createContext({
    variant: variant1,
    modelPrices: {},
});
const mapFinancial = {
    models: getModelProduct,
    trims: getTrimProduct,
};
export const SpecialOffersContextProvider = ({ variant, vehicleType, children, modelKeys, }) => {
    var _a;
    const { t } = useTranslation();
    const priceLabels = {
        allInPrice: { label: t('Shared.Common.sellingPriceStartingFromLabel') },
    };
    let productType = 'trims';
    let modelKeyId = '';
    switch (variant) {
        case variant1:
            productType = 'trims';
            modelKeyId = 'id';
            break;
        case variant2:
            productType = 'trims';
            modelKeyId = 'id';
            break;
        case variant3:
            productType = 'trims';
            modelKeyId = 'id';
            break;
        case variant4:
            productType = 'models';
            modelKeyId = 'modelKey';
            break;
        case variant5:
            productType = 'models';
            modelKeyId = 'modelKey';
            break;
        default:
            break;
    }
    const { getPrices } = usePricesFromFinancialModel(priceLabels, productType);
    const { financial, setModels } = useProductFinancial({
        vehicleType,
    });
    const [modelsAndTrims, setModelsAndTrims] = useState({
        models: [],
        trims: [],
    });
    useEffect(() => {
        if (!isEmpty(modelKeys)) {
            setModels(modelKeys);
            setModelsAndTrims(prev => ({ ...prev, models: modelKeys }));
        }
    }, [safelyStringifyJSON(modelKeys)]);
    useEffect(() => {
        if (!isEmpty(financial)) {
            setModelsAndTrims(prev => ({
                ...prev,
                trims: makeModelConfiguration(financial).modelConfigurationArray,
            }));
        }
    }, [safelyStringifyJSON(financial)]);
    const modelPrices = ((_a = modelsAndTrims[productType]) === null || _a === void 0 ? void 0 : _a.reduce((acc, model) => {
        const trimId = get(model, modelKeyId);
        const financialPayload = mapFinancial[productType](financial === null || financial === void 0 ? void 0 : financial.models, trimId);
        return {
            ...acc,
            [trimId]: getPrices(financialPayload),
        };
    }, {})) || {};
    const contextValue = useMemo(() => ({
        variant,
        modelPrices,
    }), [variant, safelyStringifyJSON(modelPrices)]);
    return _jsx(SpecialOffersContext.Provider, { value: contextValue, children: children });
};
export function useConfigurationByVariant(config) {
    var _a;
    const { variant } = useContext(SpecialOffersContext);
    if (!variant) {
        throw new Error('useConfiguration must be used within a ConfigurationProvider');
    }
    return (_a = config[variant]) !== null && _a !== void 0 ? _a : {};
}
export default SpecialOffersContext;
